import { Box, Typography } from "@mui/material";
import BackButton from "../../../UIElements/BackButton";

type SignupHeaderProps = {
    step: number;
    back: Function;
    stepsNumber: number;
};

export default function SignupHeader({
    step,
    back,
    stepsNumber,
}: SignupHeaderProps) {
    return (
        <Box
            sx={{
                background: "#FFF",
                height: "22vh",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minHeight: "22vh",
                justifyContent: "flex-start",
            }}
        >
            <BackButton
                back={back}
                classes={{
                    root: {
                        margin: 0,
                        marginLeft: "6.66%",
                        marginTop: "4vh",
                    },
                    icon: {
                        width: "1.25rem",
                        height: "1.25rem",
                    },
                    label: {
                        fontSize: "0.875rem",
                    },
                }}
            />
            <Box
                display="flex"
                sx={{
                    // width: "432px",
                    flexDirection: "column",
                    alignItems: "flexStart",
                    gap: "0.75rem",
                    margin: "auto",
                }}
            >
                <Box
                    display="flex"
                    sx={{
                        // width: "432px",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.75rem",
                    }}
                >
                    <Box
                        display="flex"
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            alignSelf: "stretch",
                            gap: "4rem",
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "Roboto",
                                fontSize: "1.125rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                                color: "#005499",
                            }}
                        >
                            Créer mon compte SOCOTEC
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                                color: "#000",
                                float: "right",
                            }}
                        >
                            {`${step}/${stepsNumber}`}
                        </Typography>
                    </Box>
                    {/* <Box
                        display="flex"
                        sx={{
                            height: "0.375rem",
                            alignItems: "center",
                            gap: "8px",
                            color: "#E3E6E8",
                        }}
                    >
                        Linear progress indicator
                    </Box> */}
                </Box>
            </Box>
        </Box>
    );
}
